// theme.ts
import { createTheme } from "@mui/material/styles";
import { blue } from "@mui/material/colors";

export const lightTheme = createTheme({
    palette: {
        mode: "light",
        primary: { main: "#1976d2" },
        background: { default: "#f7f9fb", paper: "#fff" }
    },
    shape: { borderRadius: 8 }
});

export const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: '#58a6ff',
            light: blue.A200,
            dark: "#1e5bd7",
            contrastText: "#fff"
        },
        background: { default: "#22262d", paper: "#23272e" },
        tonalOffset: 0.25 // aumenta contraste dos tons derivados
    },
    shape: { borderRadius: 8 }
});
